class ICaseHomeDeviceFinder extends HTMLElement {
  connectedCallback() {
    const dataElement = this.querySelector('[data-device-data]');
    this.categorySelect = this.querySelector('[data-device-category]');
    this.brandSelect = this.querySelector('[data-device-brand]');
    this.modelSelect = this.querySelector('[data-device-model]');
    this.submit = this.querySelector('[data-device-submit]');

    if (!dataElement || !this.categorySelect || !this.brandSelect || !this.modelSelect || !this.submit) return;

    try {
      this.devices = JSON.parse(dataElement.textContent)
        .map((device) => ({ ...device, category: device.category || 'Phone' }))
        .filter((device) => device.category && device.brand && device.model && device.url);
    } catch (error) {
      this.devices = [];
    }

    ['Phone', 'Tablet', 'Smartwatch']
      .filter((category) => this.devices.some((device) => device.category === category))
      .forEach((category) => this.categorySelect.add(new Option(category, category)));

    this.categorySelect.addEventListener('change', () => this.renderBrands());
    this.brandSelect.addEventListener('change', () => this.renderModels());
    this.modelSelect.addEventListener('change', () => this.updateSubmit());
    this.submit.addEventListener('click', (event) => {
      if (this.submit.getAttribute('aria-disabled') === 'true') event.preventDefault();
    });
  }

  renderBrands() {
    const category = this.categorySelect.value;
    this.brandSelect.replaceChildren(new Option('Select a brand', ''));

    [...new Set(this.devices
      .filter((device) => device.category === category)
      .map((device) => device.brand))]
      .forEach((brand) => this.brandSelect.add(new Option(brand, brand)));

    this.brandSelect.disabled = !category;
    this.modelSelect.replaceChildren(new Option('Select a model', ''));
    this.modelSelect.disabled = true;
    this.updateSubmit();
  }

  renderModels() {
    const category = this.categorySelect.value;
    const brand = this.brandSelect.value;
    this.modelSelect.replaceChildren(new Option('Select a model', ''));

    this.devices
      .filter((device) => device.category === category && device.brand === brand)
      .forEach((device) => this.modelSelect.add(new Option(device.model, device.url)));

    this.modelSelect.disabled = !brand;
    this.updateSubmit();
  }

  updateSubmit() {
    const url = this.modelSelect.value;
    this.submit.href = url || '#';
    this.submit.setAttribute('aria-disabled', url ? 'false' : 'true');
  }
}

if (!customElements.get('icase-home-device-finder')) {
  customElements.define('icase-home-device-finder', ICaseHomeDeviceFinder);
}
